import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'

import Icon from '@space-core/components/icon'

import styled from 'styled-components'

import { Direction } from '../enum'
import type { ArrowSlideProps } from '../types'

const ArrowWrapper = styled.div<{ direction: Direction }>`
  height: 10.25rem;
  width: 2.5rem;
  background-color: rgba(70, 75, 82, 0.3);
  ${(props) => (props.direction === Direction.RIGHT ? `right: 0` : `left: 0`)};
  ${(props) =>
    props.direction === Direction.RIGHT
      ? `border-radius: 0.5rem 0 0 0.5rem;`
      : `border-radius: 0 0.5rem 0.5rem 0;`};

  transition: width ease-in-out 0.1s, transform ease-in-out 0.1s;
  box-shadow: 0 0.25rem 1.875rem rgba(70, 75, 82, 0.1);
  backdrop-filter: blur(1rem);
  -webkit-backdrop-filter: blur(1rem);

  &:hover {
    width: 3.5rem;
    background: rgba(70, 75, 82, 0.5);
    svg {
      transform: scale(1.2);
    }
  }

  &:active {
    width: 3.5rem;
    background: rgba(70, 75, 82, 0.6);
  }
`

const ArrowSlide = ({ direction, handleClick }: ArrowSlideProps) => (
  <ArrowWrapper
    className='_d-flex _position-absolute _justify-content-center _align-items-center _cursor-pointer'
    onClick={handleClick}
    direction={direction}>
    {direction === Direction.RIGHT ? (
      <Icon
        aria-hidden
        icon={faChevronRight}
        className='_text-white _text-4'
        data-test='icon-right'
      />
    ) : (
      <Icon
        aria-hidden
        icon={faChevronLeft}
        className='_text-white _text-4'
        data-test='icon-left'
      />
    )}
  </ArrowWrapper>
)

export default ArrowSlide
